module.exports = __webpack_public_path__ + "static/media/maju_logo.d8e1c443.png";